import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router';

import { useGetUserQuery, useValidateQuery } from 'src/apiClients';
import { getIsProduction } from 'src/utils/get-is-production';
import { ROUTES } from 'src/utils/strings';

import { ApiSelector } from './api-selector';
import { NewInstanceDialog } from './new-instance-dialog/NewInstanceDialog';
import { TopBarSearch } from './top-bar-search';
import { i18n } from './TopBar.i18n';
import { useStyles } from './TopBar.styles';

export const TopBar = () => {
    const intl = useIntl();
    const { classes } = useStyles();
    const [isNewInstanceOpen, setIsNewInstanceOpen] = useState(false);
    const { pathname } = useLocation();

    const isProduction = getIsProduction();

    const { data: validateData } = useValidateQuery(undefined);
    const { data: user } = useGetUserQuery(validateData?.uid ?? '', {
        skip: !validateData?.uid,
    });
    const canCreateInstance =
        pathname === ROUTES.INSTANCES && !!user?.hasEntitlementsRole && !user.isAdminReadOnly;

    return (
        <div className={classes.container} automation-id="top-bar">
            <div className={classes.spacer} />
            <div className={classes.center}>
                <TopBarSearch />
            </div>
            <div className={classes.actions}>
                {!isProduction && <ApiSelector />}
                {canCreateInstance && (
                    <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        onClick={() => setIsNewInstanceOpen(true)}
                        automation-id="new-instance-button"
                    >
                        {intl.formatMessage(i18n.newInstance)}
                    </Button>
                )}
            </div>
            <NewInstanceDialog
                open={isNewInstanceOpen}
                onClose={() => setIsNewInstanceOpen(false)}
            />
        </div>
    );
};
